(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/info/page.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/info/page.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useParams = _ReactRouterDOM.useParams;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const NavigationBack = svs.tur.NavigationBack;
const Info = () => {
  const _svs$eInstant$shared$ = svs.eInstant.shared.hooks,
    useTicketInfo = _svs$eInstant$shared$.useTicketInfo,
    useMetaTags = _svs$eInstant$shared$.useMetaTags;
  const _useParams = useParams(),
    gameId = _useParams.gameId;
  const history = useHistory();
  const _svs$eInstant$constan = svs.eInstant.constants.ROUTES,
    INFO = _svs$eInstant$constan.INFO,
    LOBBY = _svs$eInstant$constan.LOBBY,
    CATEGORY = _svs$eInstant$constan.CATEGORY,
    ALL_GAMES = _svs$eInstant$constan.ALL_GAMES;
  const Background = svs.eInstant.shared.components.Background;
  const _svs$eInstant$lobby$p = svs.eInstant.lobby.play.utils,
    removeHashFromUrl = _svs$eInstant$lobby$p.removeHashFromUrl,
    scrollToHashAnchor = _svs$eInstant$lobby$p.scrollToHashAnchor;
  const SimilarGames = svs.eInstant.lobby.info.components.SimilarGames;
  const InfoCard = svs.eInstant.components.InfoCard;
  const _useTicketInfo = useTicketInfo({
      gameId
    }),
    _useTicketInfo$ticket = _useTicketInfo.ticketInfo,
    ticketInfo = _useTicketInfo$ticket === void 0 ? null : _useTicketInfo$ticket,
    loading = _useTicketInfo.loading;
  const _useMetaTags = useMetaTags({
      ticketInfo
    }),
    update = _useMetaTags.update;
  const isMobile = svs.core.detect.formfactor.mobile();
  const routes = {
    [LOBBY]: {
      navigate: history.push
    },
    [CATEGORY]: {
      navigate: history.push
    },
    [ALL_GAMES]: {
      navigate: history.push
    },
    [INFO]: {
      navigate: returnUrl => history.push(returnUrl || LOBBY)
    }
  };
  const onLoaded = function () {
    let hasSimilarGames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!hasSimilarGames) {
      removeHashFromUrl();
      window.scrollTo(0, 0);
      return;
    }
    scrollToHashAnchor({
      fallbackToTop: true
    });
  };
  useEffect(() => {
    ticketInfo && update(INFO);
  }, [ticketInfo, update, INFO]);
  useEffect(() => {
    var _ticketInfo$tags;
    if (ticketInfo && !((_ticketInfo$tags = ticketInfo.tags) !== null && _ticketInfo$tags !== void 0 && _ticketInfo$tags.length)) {
      removeHashFromUrl();
    }
  }, [ticketInfo, removeHashFromUrl]);
  if (!ticketInfo && !loading) {
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      type: svs.ui.dialog.type.ERROR,
      title: 'Spelet är ej tillgängligt',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: 'Försök igen senare eller kontakta kundservice.'
      }],
      actions: [{
        title: 'Okej',
        callback: () => {
          dialog.close();
          history.push(LOBBY);
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
    return React.createElement(Background, {
      classNames: "info-background"
    });
  }
  if (!ticketInfo && loading) {
    return React.createElement(Background, {
      classNames: "info-background"
    });
  }
  return React.createElement(Background, null, isMobile && React.createElement(NavigationBack, {
    brand: "fler-lotter-new",
    routes: routes
  }), React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 6,
    xs: 12
  }, React.createElement(InfoCard, {
    imageSizes: "(min-width: 1024px) calc(50vw - 36px), (min-width: 768px) calc(50vw - 30px), calc(100vw - 24px)",
    ticketConfig: ticketInfo
  }))), ticketInfo.tags && React.createElement("div", {
    className: "margin-v-2 einstant-info-similargames-anchor",
    id: "similargames"
  }, React.createElement(SimilarGames, {
    game: ticketInfo,
    onLoaded: onLoaded
  }))));
};
setGlobal('svs.eInstant.lobby.Info', Info);

 })(window);